@use "../../styles/breakpoint" as *;

.wrapper {
    composes: container from "../../styles/composable/layout.module.css";
}

.title {
    background-color: var(--blue);
    color: var(--white);
    font-size: 32px;
    font-weight: 300;
    margin-bottom: 7px;
    padding: 19px 25px;
}

.item {
    composes: grid from "../../styles/composable/layout.module.css";
    border-bottom: 1px solid var(--silver);
    padding: 18px 0;

    &:last-child {
        border-bottom: none;
    }
}

.image {
    border: 6px solid var(--white);
    grid-column: span 4;

    @media ($below-mobile) {
        grid-column: span 12;
    }
}

.content {
    color: var(--ironside);
    grid-column: span 8;

    @media ($below-mobile) {
        grid-column: span 12;
    }
}
